import { createAsyncThunk } from "@reduxjs/toolkit";

import { changeNestedArrKeyValueOnCondition, copyObj } from "core/iterable_utils";

export const editNmckCalc = createAsyncThunk("nmck/editNmckCalc", async ({ calcId, calcName }, { rejectWithValue, extra, getState }) => {
	const state = getState();
	const clickedTableRow = state.ribbon.clickedTableRow;

	try {
		const { data } = await extra.apiNmck.editCalc({
			nmck_calc_id: calcId,
			calc_name: calcName,
		});

		if (!data) {
			throw new Error();
		}

		const calcTableData = changeNestedArrKeyValueOnCondition({
			arr: copyObj(data),
			keySearch: "key",
			valSearch: clickedTableRow.key,
			keyChange: "selected",
			valChange: true,
		});

		return calcTableData;
	} catch (e) {
		return rejectWithValue(e);
	}
});
